<template>
	<v-form ref="formComodo" @submit.prevent="saveComodo">
		<v-card class="elevation-1">
			<v-toolbar flat dark color="primary">
				<v-toolbar-title>Cômodo</v-toolbar-title>
				<v-spacer />
				<v-icon @click.prevent="close">close</v-icon>
			</v-toolbar>
			<v-card-text>
				<v-form-creator :schema="schema" :root="form" />
			</v-card-text>
			<v-card-actions class="px-3 pb-3">
				<v-layout row :justify-center="!form.id">
					<v-btn
						v-if="form.id"
						:disabled="!editar || (verificada && reprovado && !critica)"
						large
						dark
						color="danger"
						:block="$vuetify.breakpoint.smAndDown"
						@click.prevent="deleteComodo"
					>
						<v-icon class="mr-2">delete</v-icon>Remover
					</v-btn>
					<v-spacer v-if="$vuetify.breakpoint.smAndUp && form.id" />
					<v-btn
						:disabled="!editar || (verificada && reprovado && !critica)"
						type="submit"
						large
						dark
						color="success"
						:block="$vuetify.breakpoint.smAndDown"
					>
						<v-icon class="mr-2">save</v-icon>Salvar
					</v-btn>
				</v-layout>
			</v-card-actions>
		</v-card>

		<v-loading :show="loading" message="Salvando" />

		<v-confirm-dialog ref="confirmDialog" />
	</v-form>
</template>

<style>
	.v-messages__wrapper {
		color: #fd2727;
	}
</style>

<script>
	import VFormCreator from '@/components/formCreator';
	import VConfirmDialog from '@/components/confirmDialog';
	import VLoading from '@/components/loading';
	import FormModel from '@/models/form';
	import api from '@/services/api';

	export default {

		components: { VFormCreator, VConfirmDialog, VLoading },
		props: ['comodo'],

		data() {
			return {
				form: new FormModel({
					residenciaComodo: null,
					quantidadePessoasDormentes: null,
					possuiJanela: null
				}),
				loading: false,
				editar: null,
				critica: false,
				reprovado: false
			};
		},

		computed: {
			schema() {
				let { required } = this.$rules;

				return [
					{
						label: 'Cômodo',
						model: 'residenciaComodo',
						cols: { sm4: true },
						disabled: !this.editar || (this.verificada && this.reprovado && !this.critica),
						items: this.$store.params.residenciaComodo,
						returnObject: true,
						rules: [required],
						class: { 'mr-2': this.$vuetify.breakpoint.smAndUp }
					},
					{
						label: 'Quantos dormem aqui?',
						model: 'quantidadePessoasDormentes',
						type: 'tel',
						cols: { sm4: true },
						disabled: !this.editar || (this.verificada && this.reprovado && !this.critica),
						mask: '####',
						rules: [required],
						class: { 'mx-2': this.$vuetify.breakpoint.smAndUp }
					},
					{
						label: 'Tem janela(s) aqui?',
						model: 'possuiJanela',
						cols: { sm4: true },
						disabled: !this.editar || (this.verificada && this.reprovado && !this.critica),
						items: [ { id: true, descricao: 'SIM' }, { id: false, descricao: 'NÃO' } ],
						returnObject: false,
						rules: [required],
						class: { 'ml-2': this.$vuetify.breakpoint.smAndUp }
					}
				];
			}
		},

		watch: {
			comodo: {
				handler() {
					if (this.comodo) {
						this.form = new FormModel(this.comodo);
					}
				},
				immediate: true
			}
		},

		async created() {
			let editar = await api.fetchStatus();

			this.editar = editar.data.operacoes.editar;

			this.reprovado = editar.data.situacaoInscricao.descricao == 'Reprovada';
			this.verificada = editar.data.verificada;

			let { criticas } = editar.data;

			let keys = Object.keys(criticas);

			for (let i = 0; i < keys.length; i++) {
				if (keys[i].includes('inscricaoResidenciaComodo')) {
					this.critica = true;
				}
			}
		},

		methods: {
			async saveComodo() {
				let url = '/inscricao/comodo';

				if (this.form.id) {
					url += `/${this.form.id}`;
				}

				if (this.$refs.formComodo.validate()) {
					try {
						this.loading = true;

						await this.form.save(url);

						this.$store.$emit('show-message', {
							message: `Cômodo ${this.form.id ? 'atualizado' : 'cadastrado'} com sucesso!`,
							color: 'success'
						});

						this.close();
					} catch ({ data: { message } }) {
						if (message) {
							this.$store.$emit('show-message', { message, timeout: 5000, color: 'danger' });
						}
					} finally {
						this.loading = false;
					}
				}
			},

			async deleteComodo() {
				this.$refs.confirmDialog
					.open(`Confirma a remoção do cômodo <strong class="primary--text">${this.form.residenciaComodo.descricao}</strong>?`)
					.then(async response => {
						if (response) {
							try {
								this.loading = true;

								await this.form.remove(`/inscricao/comodo/${this.form.id}`);

								this.$store.$emit('show-message', { message: 'Cômodo removido com sucesso!', color: 'success' });

								this.close(false);
							} catch ({ data: { message } }) {
								if (message) {
									this.$store.$emit('show-message', { message, timeout: 5000, color: 'danger' });
								}
							} finally {
								this.loading = false;
							}
						}
					});
			},

			checkCriticas() {
				if (this.comodo) {
					let keys = Object.keys(this.comodo);
					for (let i = 0; i < keys.length; i++) {
						if (keys[i].includes('critica')) {
							return true;
						}
					}
				}
				return false;
			},

			close(reset = true) {
				this.$emit('close');

				if (reset) {
					this.$refs.formComodo.reset();
				}
			}
		}
	};
</script>